// extracted by mini-css-extract-plugin
export default {"select":"Select_select__fviIL","dark":"Select_dark__FcuOB","open":"Select_open__SGUP9"};